import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import MainSliderItem from '@com/_atoms/MainSliderItem';

interface SliderItem {
  icon: string;
  blurIcon?: string;
  link?: string;
  title: string;
}

interface MainSliderCarouselProps {
  autoPlay?: boolean;
  data: SliderItem[];
  containerClassName?: string;
  swiperItemClass?: string;
  paginationPosition?: 'inside' | 'outside';
  objectFit?: 'contain' | 'cover';
  priority?: boolean;
}

const MainSliderCarousel = ({
  autoPlay = true,
  data,
  containerClassName,
  swiperItemClass = 'px-4',
  paginationPosition = 'inside',
  objectFit = 'contain',
  priority = true,
}: MainSliderCarouselProps) => {
  return (
    <div className="relative w-full">
      <Swiper
        modules={[Autoplay, Pagination]}
        slidesPerView={1}
        loop={data.length > 1}
        autoplay={
          autoPlay && data.length > 1
            ? { delay: 3000, disableOnInteraction: false }
            : false
        }
        pagination={{ clickable: true }}
        className={classNames(
          'w-full rounded-2xl overflow-hidden',
          paginationPosition === 'outside' &&
            '[&_.swiper-pagination]:!bottom-0',
        )}
      >
        {data.map((item, index) => (
          <SwiperSlide
            key={index}
            className={classNames(
              'w-full h-full flex items-center justify-center',
              paginationPosition === 'outside' && 'pb-6',
              swiperItemClass,
            )}
          >
            <MainSliderItem
              imageUrl={item.icon}
              blurDataURL={
                item.blurIcon ||
                'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACklEQVR4nGMAAQAABQABDQottAAAAABJRU5ErkJggg=='
              }
              title={item.title}
              link={item.link as string}
              containerClassName={classNames(
                'w-full relative',
                containerClassName ?? 'aspect-[23/14]',
              )}
              imageClassName={classNames(
                'rounded-2xl w-full h-full',
                objectFit === 'cover' ? 'object-cover' : 'object-contain',
              )}
              objectFit={objectFit}
              index={index}
              priority={priority && index === 0}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MainSliderCarousel;
